export default __webpack_public_path__ + "static/mini-hero-hardware-d5924f3a452179423cbc926128ded060.jpg";